import styled from "styled-components"
import { Palette, Theme } from "styles/theme"

export const Wrapper = styled.div`
  display: inline-flex;
  align-items: center;
  background-color: ${({
    $color = "primary",
    theme
  }: {
    $color?: keyof Palette
    theme: Theme
  }): string => theme.palette[$color].main};
  border-radius: 12px;
  color: ${({
    $color = "primary",
    theme
  }: {
    $color?: keyof Palette
    theme: Theme
  }): string => theme.palette[$color].contrast};
  column-gap: 6px;
  padding: 6px 12px;
`
